import React, { FC } from 'react';
import { StyledButton } from './ItemButton.styles';
import { IItemButton } from './ItemButton.type';

// button that covers the whole relative parent element
const ItemButton: FC<IItemButton> = ({ onClick, onMouseEnter, onMouseLeave, ariaLabel, ...otherProps }) => {
	return (
		<StyledButton
			type='button'
			aria-label={ariaLabel}
			aria-hidden={ariaLabel ? false : true}
			onClick={onClick ? onClick : undefined}
			onMouseEnter={onMouseEnter ? onMouseEnter : undefined}
			onMouseLeave={onMouseLeave ? onMouseLeave : undefined}
			{...otherProps}
		/>
	);
};

export { ItemButton };
